/**
 * pushApi — thin wrapper over the push endpoints (PUSH Fase 1A).
 * La REST key de OneSignal jamás llega al frontend: config solo trae
 * {enabled, app_id, account_enabled}.
 */
import { api } from "@/lib/api";

export async function getPushConfig() {
  const { data } = await api.get(`/push/config`);
  return data || { enabled: false };
}

export async function setPushPreference(enabled) {
  const { data } = await api.post(`/push/preference`, { enabled: !!enabled });
  return data;
}

/** Admin-only: se envía siempre y únicamente al admin autenticado. */
export async function sendTestPush() {
  const { data } = await api.post(`/admin/push/test`, {});
  return data;
}
